import React, { Component, Fragment } from 'react';

// this gets prefixed with "PX" in their app id, but not in the URL path.
const PX_APP_ID = 'jAYekY18';

// First-party URL via the the PerimeterX Fastly integration
const SCRIPT_URL = `/${PX_APP_ID}/init.js`;
const NOSCRIPT = `
<div style="position:fixed; top:0; left:0; display:none" width="1" height="1">
    <img src="/${PX_APP_ID}/xhr/api/v1/collector/noScript.gif?appId=PX${PX_APP_ID}" alt="PxPixel">
</div>
`;

class PerimeterX extends Component {
  static Head() {
    return (
      <Fragment>
        <script
          dangerouslySetInnerHTML={{
            __html: `(function(){ window._pxAppId = 'PX${PX_APP_ID}'; }());`
          }}
        />
        <script defer src={SCRIPT_URL} />
      </Fragment>
    );
  }
  render() {
    return <noscript dangerouslySetInnerHTML={{ __html: NOSCRIPT }} />;
  }
}

export default PerimeterX;
